import React, { useContext } from 'react';
import { FormContext } from '../../contexts/formContexts';
import { applicationFields } from '../../config/applicationConfig';
import './StepNavigator.css';
import { CREDIT_UNION } from '../../assets/constants';

const StepNavigator = () => {
  const { currentStep, setCurrentStep } = useContext(FormContext);
  const isFirst = currentStep === 0;
  const isLast = currentStep === applicationFields.length - 1;

  const handleNext = () => {
    if (!isLast) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (!isFirst) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleFinalSubmit = () => {
    alert('Final form submitted. Proceed with actual backend submission logic here!');
    
  };

  return (
    <div className="mt-4">
      {isLast && (
        <p className="pre-submit-text mb-2">
          By clicking "Submit my application!" below, I certify that everything I have stated in this application is correct. {CREDIT_UNION.INFO.NAME} may keep this application whether or not it is approved. By submitting this application I authorize {CREDIT_UNION.INFO.NAME} to verify the information I have submitted and obtain my credit report. I understand that I must update credit information at the request of {CREDIT_UNION.INFO.NAME} if my financial condition changes.
        </p>
      )}
      <div className="row">
        <div className="col-md-6">
          <button
            type="button"
            className="btn btn-outline-secondary w-100"
            onClick={handleBack}
            disabled={isFirst}
          >
            ⬅ Previous
          </button>
        </div>
        <div className="col-md-6">
          {!isLast ? (
            <button type="submit" className="btn btn-primary w-100">
              Continue ➡
            </button>
          ) : (
            // This must be type="submit" to trigger ApplicationForm's onSubmit!
            <button type="submit" className="btn btn-success w-100">
              Submit
            </button>
          )}
        </div>

        <div className="d-flex align-items-justify px-5 py-4 small gap-2 text-muted text-align-justify">
            <i className="bi bi-lock-fill" style={{ fontSize: '0.9rem' }}></i>
            <span className="mt-1" style={{ fontSize: '0.65rem', textAlign: 'justify', fontFamily: 'Poppins' }}>This webpage is secured with TLS/SSL encryption. Your data remains protected in transit, securely stored at server, and is never shared or sold. <br/> 
            
            <span style={{textAlign: 'center', width: '100%', display: 'block'}}> See <a href={CREDIT_UNION.LINKS.PRIVACY_POLICY}>PRIVACY POLICY.</a></span></span>

          </div>

      </div>
    </div>
  );
};

export default StepNavigator;